import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";

import useAPI from "../../../../api/hooks/useAPI";
import { integrationKeys } from "../../../../api/queryKeys";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { Toast } from "../../../../components/Toast";

export default function PerceptionPointConnectForm({ guideMode = false }) {
  const [showSecret, setShowSecret] = useState(false);
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const { registerPerceptionPointIntegration } = useAPI();

  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);

  const formInitialValues = {
    api_key: "",
  };

  const formCheckoutSchema = yup.object().shape({
    api_key: yup.string().required("required"),
  });

  const handleFormSubmit = (values) => {
    setLoading(true);
    registerPerceptionPointIntegration(values.api_key.trim())
      .then((response) => {
        queryClient.invalidateQueries({
          queryKey: integrationKeys.all,
        });
        Toast.success("Perception Point integration successful");
      })
      .catch((error) => {
        if (error.response) {
          Toast.error(`Something went wrong: ${error.response.data.detail}`);
        } else {
          Toast.error("An error occurred while processing the request.");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Formik
      onSubmit={handleFormSubmit}
      initialValues={formInitialValues}
      validationSchema={formCheckoutSchema}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
      }) => (
        <Form>
          <Box display="grid" mb="20px" gap="10px">
            <TextField
              fullWidth
              variant="filled"
              name="api_key"
              label="API Key"
              value={values.api_key}
              onBlur={handleBlur}
              onChange={handleChange}
              autoComplete="off"
              type={showSecret ? "text" : "password"}
              error={!!touched.api_key && !!errors.api_key}
              helperText={
                touched.api_key && errors.api_key
                  ? String(errors.api_key)
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle api key visibility"
                      onClick={handleClickShowSecret}
                      onMouseDown={handleMouseDownSecret}
                    >
                      {showSecret ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              disabled={guideMode}
            />
          </Box>
          <Box display="flex" justifyContent="center">
            <PrimaryButton type="submit" disabled={guideMode || loading}>
              Connect
            </PrimaryButton>
          </Box>
        </Form>
      )}
    </Formik>
  );
}